export default function TestimonialSection() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-20">
          <div className="w-full lg:w-[40%]">
            <div className="rounded-3xl overflow-hidden bg-accent-100 aspect-[3/4] max-w-md mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20woman%20in%20modern%20casual%20blazer%20and%20light%20neutral%20outfit%20sitting%20at%20a%20clean%20desk%20looking%20at%20laptop%20screen%20showing%20organized%20data%2C%20warm%20natural%20studio%20lighting%20from%20window%20creating%20soft%20flattering%20shadows%2C%20confident%20approachable%20expression%2C%20editorial%20business%20portrait%20style%20with%20cream%20background%2C%20sophisticated%20yet%20friendly%20corporate%20photography%2C%20modern%20workspace%20atmosphere&width=800&height=1067&seq=testimonial-person-v3&orientation=portrait"
                alt="Professional using ACBuySpreadsheet"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1">
            <span className="inline-block text-xs font-medium text-foreground-500 uppercase tracking-wider font-label">
              (SEO Authority)
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mt-3 leading-tight">
              Why ACBuySpreadsheet
              <br />
              <span className="text-foreground-400">Ranks Higher</span>
            </h2>

            <blockquote className="mt-8 md:mt-10 text-foreground-700 text-base md:text-lg leading-relaxed italic max-w-xl">
              "The acbuy spreadsheet tracking system has completely transformed how we manage our ecommerce data. The automation capabilities are unmatched, and the SEO-optimized structure gives our content a significant ranking advantage. After switching from manual tracking methods, our team's productivity increased by over 60% within the first month. This is genuinely the most efficient spreadsheet solution we have ever used."
            </blockquote>

            <p className="mt-6 text-foreground-950 font-bold text-sm">
              &mdash; Certified SEO Team
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}